export const PRIORITIES = ['Low', 'Medium', 'High'];
export const PRODUCT_TYPES = ['ProdType1', 'ProdType2', 'ProdType3'];
export const INITIATIVE_STATUS = ['Created', 'Approved', 'Implemented', 'Done'];
export const ISSUE_TYPES = ['Release', 'Marketing', 'Change Mgmt'];



// WEBPACK FOOTER //
// ./constants/lists.js